export default "__VITE_ASSET__kHxtETOI__"